import { Component, Input } from '@angular/core';
import { PQRAdicionaisDto } from '../../dtos';
import { NgFor, NgIf } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TabelaComponent } from '../tabela/tabela.component';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-dialog-pqr-adicionais',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    MatDialogModule,
    MatButtonModule,
    TabelaComponent
  ],
  templateUrl: './dialog-pqr-adicionais.component.html',
  styleUrl: './dialog-pqr-adicionais.component.scss'
})
export class DialogPqrAdicionaisComponent{
  @Input() dadosTabela: PQRAdicionaisDto[] = [];

  constructor(public featureFlagService: FeatureFlagService) {}
}

